import { OrganizationSettingKey } from '@modules-deprecated/app/organization'

import { FEATURE_PREFIX } from '../constants/featurePrefix'
import { FEATURE_PREFIX_SEPARATOR } from '../constants/featurePrefixSeparator'
import { OrganizationFeature } from '../enums/organizationFeature'

export const getOrganizationSettingBetaKey = (featureName: OrganizationFeature): OrganizationSettingKey =>
  `${FEATURE_PREFIX}${FEATURE_PREFIX_SEPARATOR}${featureName}` as OrganizationSettingKey
